export default "__VITE_ASSET__CfAPnisk__"